<script lang="ts" setup>
import { useValidator } from '@/composeables/validator';
import type { ValidatorDef } from '@/objects/gui/ValidatorDef';

const props = withDefaults(
    defineProps<{
        value: number | null;
        validator?: ValidatorDef | null;

        /**
         * Whether to format the number eiter using the locale or using 3 digits grouping
         * @default undefined
         */
        format?: '3digit' | 'locale';
    }>(),
    { value: null },
);

const formatValue = (value: number | null) => {
    if (value == null) {
        return '';
    }

    if (props.format === '3digit') {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else if (props.format === 'locale') {
        return value.toLocaleString();
    }
    return props.value;
};

const { ValidateMessage } = useValidator(props.validator ?? null, props.value);
</script>

<template>
    <div
        class="field-renderer-number text-right"
        :class="[ValidateMessage != null ? 'justify-content-end pe-4 alert alert-' + ValidateMessage.type : '']"
    >
        {{ formatValue(value) }}
    </div>
</template>
